var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TRANSACTION_HISTORY, TRANSACTION_HISTORY_FILTER, TRANSACTION_HISTORY_SEARCH, TRANSACTION_HISTORY_SORT, TRANSACTION_HISTORY_EDITABLE, TRANSACTION_HISTORY_ALL_TXNS_ERROR, TRANSACTION_HISTORY_ALL_TXNS_LOADER, TRANSACTION_HISTORY_ALL_TXNS, TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR, } from "@redux/interfaces/Reports/iTransactionHistory";
import { combineReducers } from "redux";
import commonOnePlatFormReducer, { CommonOnePlatFormInitState, } from "@redux/reducers/common/commonReducer";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
var initData = {
    transactionHistory: {
        totalRecords: 0,
        numberOfPages: 0,
        pageSize: 0,
        transactionList: [],
    },
    SearchData: "",
    FilterData: {
        simpleFilter: {
            name: "",
            filters: [],
        },
        assetFilter: {
            name: "",
            filters: [],
        },
        underlyingAsset: {
            name: "",
            filters: [],
        },
    },
    SortData: {
        sortState: [],
        sortRecord: {},
        data: {
            totalRecords: 0,
            numberOfPages: 0,
            pageSize: 0,
            transactionList: [],
        },
    },
    editableTxns: [],
    allTransactionHistory: {
        totalRecords: 0,
        numberOfPages: 0,
        pageSize: 0,
        transactionList: [],
    },
    allTxnLoader: false,
    allTxnError: {
        error: undefined,
        isOpen: false,
    },
};
var TransactionHistoryReducer = function (state, action) {
    if (state === void 0) { state = initData; }
    switch (action.type) {
        case TRANSACTION_HISTORY:
            return __assign(__assign({}, state), { transactionHistory: action.payload.transactionHistory });
        case TRANSACTION_HISTORY_FILTER:
            return __assign(__assign({}, state), { FilterData: action.payload.FilterData });
        case TRANSACTION_HISTORY_SEARCH:
            return __assign(__assign({}, state), { SearchData: action.payload.SearchData });
        case TRANSACTION_HISTORY_SORT:
            return __assign(__assign({}, state), { SortData: action.payload.SortData });
        case TRANSACTION_HISTORY_EDITABLE:
            return __assign(__assign({}, state), { editableTxns: action.payload.editableTxns });
        case TRANSACTION_HISTORY_ALL_TXNS:
            return __assign(__assign({}, state), { allTransactionHistory: action.payload.allTransactionHistory });
        case TRANSACTION_HISTORY_ALL_TXNS_LOADER:
            return __assign(__assign({}, state), { allTxnLoader: action.payload.allTxnLoader });
        case TRANSACTION_HISTORY_ALL_TXNS_ERROR:
            return __assign(__assign({}, state), { allTxnError: action.payload.allTxnError });
        case TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR:
            return __assign(__assign({}, state), { allTxnError: initData.allTxnError });
        default:
            return __assign({}, state);
    }
};
export default combineReducers({
    reducersData: TransactionHistoryReducer,
    commonData: function (state, action) {
        if (state === void 0) { state = new CommonOnePlatFormInitState(); }
        return commonOnePlatFormReducer(state, action, ERevampReportReducers.TRANSACTION_HISTORY);
    },
});
